import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleBigqueryLogo = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "a",
		x1: .5,
		x2: .5,
		y1: 0,
		y2: 1,
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: 0,
			stopColor: "#4387fd"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#4683ea"
		})]
	}) }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("title", { children: "Layer 1" }),
		/* @__PURE__ */ _jsx("path", {
			stroke: "null",
			fill: "url(#a)",
			d: "m5.20369,21.59737l-4.92685,-8.53387a2.15824,2.15824 0 0 1 0,-2.15824l4.92685,-8.53368a2.15843,2.15843 0 0 1 1.86939,-1.07922l9.8537,0a2.15843,2.15843 0 0 1 1.8692,1.07922l4.92685,8.53368a2.15824,2.15824 0 0 1 0,2.15843l-4.92685,8.53368a2.15843,2.15843 0 0 1 -1.8692,1.07903l-9.8537,0a2.15824,2.15824 0 0 1 -1.86939,-1.07922l0,0.00019z",
			id: "svg_1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "null",
			d: "m22.36584,16.20373l-7.24557,-7.24595l-3.12034,-0.83503l-2.80277,1.04168l-1.08241,2.82004l0.87032,3.13986l7.68364,7.68364l1.63046,-0.07245l4.06667,-6.53179z",
			clipPath: "url(#b)",
			opacity: .07,
			id: "svg_2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "null",
			fill: "#fff",
			id: "svg_3",
			children: [/* @__PURE__ */ _jsx("path", {
				stroke: "null",
				d: "m12.22882,8.05469c-2.4043,0 -4.35346,1.94916 -4.35346,4.35365c0,2.4043 1.94916,4.35346 4.35346,4.35346s4.35327,-1.94916 4.35327,-4.35346c0,-2.40449 -1.94916,-4.35365 -4.35327,-4.35365m0,7.6568c-1.82434,0 -3.30334,-1.47899 -3.30334,-3.30334s1.47899,-3.30315 3.30334,-3.30315s3.30334,1.47899 3.30334,3.30334s-1.47899,3.30334 -3.30334,3.30334",
				id: "svg_4"
			}), /* @__PURE__ */ _jsx("path", {
				stroke: "null",
				d: "m10.16236,12.24016l0,1.35324a2.4013,2.4013 0 0 0 0.82208,0.83991l0,-2.19315l-0.82208,0zm1.63008,-1.14078l0,3.64324c0.13983,0.02571 0.28285,0.04129 0.42981,0.04129c0.13401,0 0.26464,-0.01408 0.39283,-0.03547l0,-3.64906l-0.82264,0zm1.70629,1.7031l0,1.607a2.3998,2.3998 0 0 0 0.82246,-0.88214l0,-0.72467l-0.82246,-0.00019zm1.86282,2.28737l-0.45102,0.45139a0.20421,0.20421 0 0 0 0,0.28848l1.71079,1.71023a0.20421,0.20421 0 0 0 0.28848,0l0.45102,-0.45083a0.20496,0.20496 0 0 0 0,-0.28829l-1.71098,-1.71098a0.20458,0.20458 0 0 0 -0.28829,0",
				id: "svg_5"
			})]
		})
	] }));
});
export default SvgGoogleBigqueryLogo;
